import PromptInput from "common/widgets/PromptList/PromptInput";
import PossiblyFilterableDropDownList from "app/widgets/DFDropDownList/PossiblyFilterableDropDownList";
import DFComboBox from "app/widgets/DFComboBox/DFComboBox";
import ManyInput from "app/widgets/ManyInput/ManyInput";
import DFMultiSelect from "app/widgets/DFMultiSelect/DFMultiSelect";
import listValue from "common/search/listValue";
import DataType from "common/enums/DataType";
const ListPromptInput = PromptInput.extend({
    options: {
        name: "ListPromptInput",
        template: "<select>"
    },

    events: [
        "customValueAdded",
        "inputSelect"
    ],

    init: function(element, options) {
        PromptInput.fn.init.apply(this, arguments);

        this.widget = this._render();
        this.widget.wrapper.attr("title", this.options.model.tooltip);
        if (this.widget.input) {
            this.widget.input.attr("title", this.options.model.tooltip);
        }
        // set class needed for applying styles to set width / height / labelPosition correctly,
        // based on control type
        if (this.options.model.width && this.options.model.height) {
            this.element.parent().addClass("dropdownControl flexLayout");
        }

        // add class to the animation container, only when using font styles
        if (this.options.model.fontFamily && this.options.model.fontSize) {
            this.widget.bind("open", $.proxy(this._openedDropDown, this));
        }

        this.widget.bind("change", this.handleChange);
        this.refresh();
    },

    canControlAcceptFocusWithNoData: function() {
        return this.options.model.get("datasourceEditable") === true || this.options.model.get("listEditable") === true;
    },

    onInit: function(promptList) {
        PromptInput.fn.onInit.apply(this, arguments);
        this.bind("customValueAdded", function(evt) {
            promptList.trigger("customValueAdded", evt);
        });
    },

    destroy: function() {
        if (this.widget) {
            this.widget.unbind("change");
            this.widget.unbind("open");
            this.widget.unbind("customValueAdded");
        }

        PromptInput.fn.destroy.apply(this, arguments);
    },

    /**
     * Override the handle change handler to set the key field as well as the value field.
     * NOTE: we are intentionally not using dataValueField for keys.  The key values are only to be used
     * for datasource arguments into other fields, they are never saved as the value of a prompt.
     */
    handleChange: function() {
        // NOTE: indexing keys are only supported by single value inputs.
        // When the datasource is editable, the key is only possible for the predefined values, not custom values.
        var selected = this.widget.select && this.widget.select();
        if (selected) {
            var item = this.widget.dataItem(selected);
            this.options.model.set("key", item ? item.key : this.value());
        }

        PromptInput.fn.handleChange.apply(this, arguments);

        // trigger selection change if the input is not a multiselect
        if (this.options.model.allowMultipleValues !== true && this.widget.value && this.widget.value()) {
            this.trigger("inputSelect");
        }
    },

    /**
     * Render and return the input to a particular input based on its properties.
     * @private
     */
    _render: function() {
        var ret;
        if (this.options.model.allowMultipleValues !== true) {
            if (this.options.model.listEditable !== true) {
                ret = this._renderDropDown();
            } else {
                ret = this._renderComboBox();
            }
        } else {
            if (this.options.model.listEditable !== true) {
                ret = this._renderMulti();
            } else {
                ret = this._renderAuto();
            }
        }

        return ret;
    },

    /**
     * Render a non-user-editable, multi-select input.
     * @private
     */
    _renderMulti: function() {

        // we need to wrap data items to provide a label,
        // and add an "all" option at index 0.
        // NOTE: we are specifically not using the legacy "key" field as the value field.
        // The only use case for the "key" field is when passing an argument to execute a datasource.
        var data = this.getData().map(function(item) {
            item.label = item.value;
            return item;
        });
        this.parseValue = this._parseMultiValue;

        return new DFMultiSelect(this.input, {
            dataSource: {
                data: data
            },
            filter: "contains",
            accessibleMode: true,
            placeholder: this.options.model.placeholderValue,
            dataTextField: "label",
            dataValueField: "value",
            autoClose: false,
            selectAll: true
        });
    },

    /**
     * Render a user-editable, multi-select input.
     * @private
     */
    _renderAuto: function() {
        var me = this;
        this.parseValue = this._parseMultiValue;
        return new ManyInput(this.input, {
            widget: DFComboBox,
            widgetOptions: {
                dataSource: {
                    data: this.options.model.data
                },
                dataTextField: "value",
                dataValueField: "value",
                maxlength: this.options.model.maxLength,
                placeholder: this.options.model.placeholderValue,
                characterCase: this.options.model.characterCase
            },
            inputCreated: function(e) {
                me.addFocusables([e.widget, e.add, e.remove]);
            }
        });
    },

    /**
     * Override
     * Ensure default value of null (DefaultValueApply) is maintained when there is no value
     * @param x
     * @returns {*}
     * @private
     */
    _parseMultiValue(x) {
        if(!x || !x.length) {
            return null;
        }
        return x;
    },

    /**
     * Render a non-user-editable, single-select input.
     * @private
     */
    _renderDropDown: function() {
        var template = listValue.valueFormatter(this.options.model, "value");
        listValue.addTextField(this.options.model);
        //Mantis #34308/#34416: Search/Dashboards and BPM have different behavior on optional prompts with a default value
        //BPM: It there is a default value, do not show the option label
        //Search: If there is a default, show the option label
        //These should be brought in line(#34424)
        var alwaysOptionLabel = !this.options.model.required && !this.options.model.bpmType;
        var showOptionLabel = alwaysOptionLabel || (!this.options.model.bpmType || !this.options.model.strDefaultValue);
        var customOptionLabel = !!this.options.model.placeholderValue;
        var canFilter = this.options.model.dataType === DataType.STRING;
        return new PossiblyFilterableDropDownList(this.input, {
            dataSource: {
                data: this.options.model.data
            },
            dataTextField: "text",
            dataValueField: "value",
            filterType: canFilter ? "contains" : "none",
            valueTemplate: template,
            template: template,
            optionLabel: customOptionLabel ? this.options.model.placeholderValue : undefined,
            optionLabelKey: !customOptionLabel && showOptionLabel ? "select" : undefined,
            keepOptionLabel: alwaysOptionLabel,
            index: !customOptionLabel && !alwaysOptionLabel ? -1 : undefined
        });
    },

    /**
     * Render a user-editable, single-select input.
     * @private
     */
    _renderComboBox: function() {
        listValue.addTextField(this.options.model);
        this.formatValue = listValue.converter(this.options.model);
        this.parseValue = listValue.converterBack(this.options.model);
        var ret = new DFComboBox(this.input, {
            dataSource: {
                data: this.options.model.data
            },
            maxlength: this.options.model.maxLength,
            dataTextField: "text",
            dataValueField: "value",
            placeholder: this.options.model.placeholderValue,
            characterCase: this.options.model.characterCase
        });

        // Indexing has a feature where custom values entered by users are stored for the duration of the session.
        if (this.options.model.storeCustomValues) {
            var me = this;
            ret.bind("change", function() {
                // figure out if the user entered a value that is not present in the data source
                var val = ret.value();
                if (ret.select() === -1 && val) {

                    // trigger an event so that some view model can store the custom value, since this prompt
                    // will be destroyed often, we can't store it here.
                    me.trigger("customValueAdded", {
                        shortName: me.options.model.name,
                        val: me.parseValue(val)
                    });
                }
            });
        }

        return ret;
    },

    /**
     * Override
     * List can return multiple inputs for multivalue string mdos
     * @return {widget.wrapper|*}
     */
    _getFocusWidgets: function(showAll) {
        if (this.options.model.allowMultipleValues && this.options.model.listEditable && this.widget) {
            return this.widget.getFocusWidgets(showAll);
        }
        return PromptInput.fn._getFocusWidgets.apply(this, arguments);
    },

    /**
     * Override
     * @private
     */
    disableTabbable: function() {
        PromptInput.fn.disableTabbable.apply(this, arguments);
        if (this.widget && this.widget.disableTabIndex) {
            this.widget.disableTabIndex();
        }
    },

    /**
     * Add classes to the animation container for the dropdown list, which isn't created until the dropdown is opened
     * for the first time.
     * @private
     */
    _openedDropDown: function() {
        var me = this;
        setTimeout(function() {
            me.widget.list.addClass(me.options.model.fontFamily);
            me.widget.list.addClass("font" + me.options.model.fontSize);
        }, 100);
    },

    getMinSize: function() {
        var minSize = PromptInput.fn.getMinSize.apply(this, arguments);
        minSize.width = 60;
        return minSize;
    },

    getInputWidth: function() {
        return this.widget.wrapper.outerWidth(true);
    },

    /**
     * Override
     */
    commitValue() {
        const focusedWidget = this._getFocused();
        if(focusedWidget instanceof DFComboBox) {
            const e = {relatedTarget: $()};
            focusedWidget._inputFocusout(e);
        } else if(focusedWidget instanceof PossiblyFilterableDropDownList && !focusedWidget.filterInput) {
            focusedWidget._focusoutHandler();
        } else {
            PromptInput.fn.commitValue.apply(this, arguments);
        }
    }
});
kendo.ui.plugin(ListPromptInput);
export default ListPromptInput;
